import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { api } from '../lib/api';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const [status, setStatus] = useState('polling');
  const { refresh } = useAuth();

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === 'paid') {
          setStatus('paid');
          refresh();
          return;
        }
      } catch {}
      attempts++;
      if (attempts < 10) setTimeout(poll, 2000);
      else setStatus('timeout');
    };
    poll();
  }, [sessionId, refresh]);

  return (
    <div className="max-w-md mx-auto py-12 text-center">
      <Card className="glass p-8">
        {status === 'polling' && (<><Loader2 className="w-14 h-14 mx-auto text-violet-400 animate-spin" /><h1 className="font-display text-2xl font-bold mt-4">Confirming your payment…</h1><p className="text-sm text-slate-400 mt-2">This usually takes a few seconds</p></>)}
        {status === 'paid' && (<><CheckCircle2 className="w-14 h-14 mx-auto text-emerald-400" /><h1 data-testid="payment-success-title" className="font-display text-2xl font-bold mt-4">You're in! Welcome to Premium 🎉</h1><p className="text-sm text-slate-400 mt-2">Your account has been upgraded</p><Link to="/"><Button data-testid="pay-success-home" className="mt-6 gradient-brand text-white">Continue to Jixxeo AI</Button></Link></>)}
        {status === 'timeout' && (<><h1 className="font-display text-xl font-bold mt-4">Still processing…</h1><p className="text-sm text-slate-400 mt-2">Refresh this page in a moment.</p></>)}
      </Card>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="max-w-md mx-auto py-12 text-center">
      <Card className="glass p-8">
        <XCircle className="w-14 h-14 mx-auto text-slate-400" />
        <h1 data-testid="payment-cancel-title" className="font-display text-2xl font-bold mt-4">Checkout cancelled</h1>
        <p className="text-sm text-slate-400 mt-2">No charge was made. You can try again anytime.</p>
        <Link to="/subscriptions"><Button data-testid="pay-cancel-retry" className="mt-6 gradient-brand text-white">Back to plans</Button></Link>
      </Card>
    </div>
  );
}
